import mapSliceToComponent from '~/imports/shop_page'
import { STORYBLOK_TYPES } from '~/lib/storyblok-types'

import { LinkProps } from '@unlikelystudio/react-abstract-components'

import SliceManager from '~/components/Abstracts/SliceManager'
import { PageViewAnalytics } from '~/components/PageViewAnalytics'
import ShopsNavigation from '~/components/ShopsNavigation'

import { getStaticPathsFunction } from '~/data/page-data'
import { DefaultPageData } from '~/data/page-data/serializer'
import getShopPageStaticPropsFunction from '~/data/shop-page-data'

import css from './styles.module.scss'

export type ShopPage = DefaultPageData & {
  shopsNavigationItems: LinkProps[]
}
export default function Shop({ slices, shopsNavigationItems }: ShopPage) {
  return (
    <div className={css.container}>
      <ShopsNavigation items={shopsNavigationItems} />
      <SliceManager
        mapSliceTypeToComponent={mapSliceToComponent}
        slicesData={slices}
      />
      <PageViewAnalytics template="page" />
    </div>
  )
}

export const getStaticProps = getShopPageStaticPropsFunction()

export const getStaticPaths = getStaticPathsFunction({
  type: STORYBLOK_TYPES.SHOP,
})
